


import TiwiMixin from '../mixins/TiwiMixin';
import LikeButton from './LikeButton';
import ContentCard from './ContentCard';

export default {
  mixins: [ TiwiMixin ],
  components: {
    LikeButton,
    ContentCard,
  },
  props: {
    posts: {
      required: true,
      type: Array,
    },
  },
  data() {
		return {

		}
	},
  computed: {

  },
  methods: {

  },
  computed: {

  },
  watch:{

  }
}
